import account from 'Agent/Accounts/ducks/account';
import accountDetails from 'Agent/Accounts/ducks/accountDetail';
import enrollmentApplication from 'Agent/Accounts/ducks/enrollmentApplication';
import discrepancySummary from './discrepancySummary';

export default {
  accountDetails,
  account,
  discrepancySummary,
  enrollmentApplication,
};
